export function parseTokenCommand(message: string): string | null {
    const match = /^\/token(?:\s+(.*))?$/i.exec(message);
    if (!match) {
        return null;
    }

    return match[1]?.trim() ?? '';
}

export function parseDebugCommand(message: string): boolean | null {
    const trimmed = message.trim();
    if (/^\/debug$/i.test(trimmed)) {
        return true;
    }

    if (/^\/debug\s+off$/i.test(trimmed)) {
        return false;
    }

    return null;
}

export function parseLanguageCommand(message: string): string | null {
    const match = /^\/lang(?:\s+(.*))?$/i.exec(message);
    if (!match) {
        return null;
    }

    return match[1]?.trim() ?? '';
}
